module.exports = __webpack_public_path__ + "static/media/34.b752aa1d.jpg";